import { getCurrentOrg } from './getCurrentOrg';
import { TelecomApiService } from '../services';
import type { AgentInboundPhoneNumberDto } from '../services';
import type { CredentialDto, PhoneNumberDto } from '../services';

export type SipProviderDto = {
  id: string;
  name: string;
  description: string | null;
};

export type TelephonyResultType = CredentialDto & {
  providerId?: string | null;
};
export type InboundPhoneNumberType = PhoneNumberDto;
export type OutboundPhoneNumberType = PhoneNumberDto;
export type InboundTelephonyListItemType = AgentInboundPhoneNumberDto;

export const getTelephony = async (): Promise<TelephonyResultType> => {
  return TelecomApiService.getCredential(getCurrentOrg());
};
export const updateTelephony = async (form: TelephonyResultType) => {
  return TelecomApiService.putCredential(getCurrentOrg(), form);
};

export const getInboundNumbers = (agentId: string) => {
  return TelecomApiService.getInboundPhoneNumbers(getCurrentOrg(), agentId);
};
export const getOutboundNumbers = () => {
  return TelecomApiService.getOutboundPhoneNumbers(getCurrentOrg());
};

export const addInboundPhoneNumber = (
  agentId: string,
  phone: PhoneNumberDto
) => {
  return TelecomApiService.putInboundPhoneNumber(
    getCurrentOrg(),
    agentId,
    phone
  );
};
export const addOutboundPhoneNumber = (phone: PhoneNumberDto) => {
  return TelecomApiService.putOutboundPhoneNumber(getCurrentOrg(), phone);
};
export const deleteInboundPhoneNumber = (
  agentId: string,
  phone: PhoneNumberDto
) => {
  return TelecomApiService.deleteInboundPhoneNumber(
    getCurrentOrg(),
    agentId,
    phone.id!
  );
};
export const deleteOutboundPhoneNumber = (phone: PhoneNumberDto) => {
  return TelecomApiService.deleteOutboundPhoneNumber(
    getCurrentOrg(),
    phone.id!
  );
};

export const getInboundListForOrganization = async () => {
  return TelecomApiService.getAgentInboundPhoneNumbers(getCurrentOrg());
};
